import React from 'react';
import data from '../../ourDoctors.json';

const { doctorDetails } = data;

const DoctorCardMukta = () => {
    const { id, heading, items, } = doctorDetails;

    return (
        <section id={id} className="w-full bg-white  ava-section-gap">
            <div className="container mx-auto px-4 md:px-8">
                {/* ── Doctor Cards ── */}
                <div className="flex flex-col gap-5 md:gap-6  mx-auto">
                    {items.map((doctor) => (
                        <DoctorCard key={doctor.id} doctor={doctor} />
                    ))}
                </div>

            </div>
            {/* <div className='' style={{backgroundColor:"var(--secondary-color)"}}>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-2 max-w-[90%] mx-auto mt-10'>

                    {items[0].specializations.map((spec, index) => (
                        <p key={index} className=' text-sm mt-4 text-gray-600'>{spec}</p>
                    ))}
                </div>

            </div> */}
        </section>
    );
};

/* ── Individual Doctor Card ── */
const DoctorCard = ({ doctor, key }) => (
    <div
        className="flex items-center flex-col lg:flex-row-reverse rounded-2xl overflow-hidden ava-card-bg "
    // style={{ flexDirection: 'row-reverse' }}
    >
        {/* ── Left: Doctor photo ── */}
        <div
            className="relative w-full sm:w-[220px] md:w-[260px] lg:w-[280px] h-[220px] flex items-center justify-center  sm:h-auto flex-shrink-0  "
            style={{ width: '100%', maxWidth: '400px', minHeight: '300px', height: '500px' }}
        >
            <img
                src={doctor.image}
                alt={doctor.name}
                className="w-full h-full object-cover object-top ava-card-image ava-radius-md"
                draggable={false}
            />
        </div>

        {/* ── Right: Doctor details ── */}
        <div className="flex flex-col justify-center gap-3 px-5 py-6 md:px-8 md:py-7 flex-1">
            <h2 className='text-center ava-heading-lg primary-text '>{doctor.name}</h2>
            <p className="ava-text-subheading text-center ">{doctor.qualification}</p>
            <p
                className="ava-text-body"
                style={{ whiteSpace: 'pre-wrap' }}
            >
                {/* {doctor.bio} */}
                {doctor.bio.replace(/\/n/g, '\n')}
            </p>
            {doctor.focusAreas && (
                <div className="ava-text-body">
                    <span className="font-semibold">
                        <span className="mt-1">• </span>
                        Her focus areas include:</span>

                    <ul className="mt-2 space-y-1">
                        {doctor.focusAreas
                            .replace("Her focus areas include:", "")
                            .split("|")
                            .map((area, index) => (
                                <span key={index} className=" gap-2">
                                    <span>{area.trim()} | </span>
                                </span>
                            ))}
                    </ul>
                </div>
            )}
        </div>
    </div>
);

export default DoctorCardMukta;